module.exports = __webpack_public_path__ + "static/media/PushtimargImage36.7cd8765c.jpg";